import styled from "styled-components";
import theme from "../common/theme";

export const Vertical = styled.div`
    width: 1px;
    background: ${theme.palette.border};
    // height: 1.5rem;
    height: 100%;
    display: inline-block;
`;

export const Horizontal = styled.div`
    flex: 1;
    border-top: 1.5px solid ${theme.palette.border};
    margin: 1rem 0;
`;


export default {
    Horizontal,
    Vertical
}